import React, { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useAuth } from "../../contexts/AuthContext";
import api from "../../../api/axios"; 

export const AxiosInterceptor: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isAuthenticated, logout } = useAuth();

  useEffect(() => {
    const responseInterceptor = api.interceptors.response.use(
      (response) => response,
      async (error) => {
        const status = error.response?.status || 500;
        if (status === 401 && isAuthenticated) {
          await logout();
          window.location.href = "/";
        }

        Sentry.captureException(error);
        return Promise.reject(error);
      }
    );

    return () => {
      api.interceptors.response.eject(responseInterceptor);
    };
  }, [isAuthenticated, logout]);

  return <>{children}</>;
};